/* eslint-disable @typescript-eslint/indent */

/* Note: please be careful with indentation, we have the rule disabled because of
*  eslint not being able to properly indent js inside styled components
*/

// Core
import styled from 'styled-components';

// Config
import { BREAKPOINTS } from '../../config/screen';

// Layout
import { Button } from '../../layout/elements/Button';

export const PasswordRecoveryContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
`;

export const FormContentContainer = styled.div`
  margin: auto;
`;

export const TitleContainer = styled.div`
  padding-top: 1.5rem;

  @media (min-width: ${BREAKPOINTS.md}px) {
    padding-bottom: 2rem;
    padding-top: 0;
  },

  @media (min-width: ${BREAKPOINTS.lg}px) {
    padding-top: 0.8125rem;
    padding-bottom: 0;
  },
`;

export const Description = styled.div`
  padding: 1.5rem 0 2rem 0;
  text-align: center;
  max-width: 380px;

  @media (min-width: ${BREAKPOINTS.md}px) {
    padding: 0 0 2rem 0;
  },

  @media (min-width: ${BREAKPOINTS.lg}px) {
    padding: 2rem 0 3rem 0;
  };
`;

export const AlertContainer = styled.div`
  padding-bottom: 0.75rem;

  @media (min-width: ${BREAKPOINTS.md}px) {
    padding-bottom: 0.625rem;
  },

  @media (min-width: ${BREAKPOINTS.lg}px) {
    padding-bottom: 0.5rem;
  },
`;

export const InputEmailContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding-bottom: 1.5rem;

  @media (min-width: ${BREAKPOINTS.md}px) {
    padding-bottom: 1rem;
  },

  @media (min-width: ${BREAKPOINTS.lg}px) {
    padding-bottom: 2rem;
  },
`;

export const BoldText = styled.strong`
  font-family: ${({ theme }) => theme.font.bold};
  color: ${({ theme }) => theme.color.paragraph.default};
`;

export const InlineButton = styled(Button)`
  display: inline !important;
  height: auto !important;
  width: auto !important;
  margin: 0 !important;
  padding: 0 !important;
  color: ${({ theme }) => theme.color.button.primaryType.primaryColor.backgroundColor};
  font: inherit !important;
  
  &:hover {
    color: ${({
      theme,
    }) => theme.color.button.primaryType.primaryColor.hoverBackgroundColor} !important;
  },
`;
